class Members {
    constructor(vpnUserNames, memberGroups, ajax = false) {
        this.vpnUserNames = vpnUserNames;
        this.memberGroups = memberGroups;
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');

        if(ajax === false){
            this.tabChange();

            if(window.location.href.indexOf('#add_member') !== -1) {
                let inviteMemberModal = document.getElementById('invite_team_members_modal');
                if(inviteMemberModal){
                    new bootstrap.Modal(inviteMemberModal, {}).show();
                } else {
                    let addMemberModal = document.getElementById('members_add_device_modal');
                    new bootstrap.Modal(addMemberModal, {}).show();
                }
            }
            this.exportMembersToCsv();
        }

        this.inviteMemberFormValidation();
        this.addDeviceFormValidation();
        this.createMemberGroupForm();
    }
    tabChange(){
        $('.members-tab-menu .nav-link').on('click', function () {
            let toolbarToShow = $(this).attr('data-show-toolbar');
            $('.card-toolbar').addClass('d-none');
            if(toolbarToShow){
                $(toolbarToShow).removeClass('d-none');
            }
        });

        if(window.location.href.indexOf('#groups_tab') !== -1) {
            const groupsTab = document.querySelector('.nav-link[href="#groups_tab"]');
            bootstrap.Tab.getOrCreateInstance(groupsTab).show();
            $('.card-toolbar').addClass('d-none');
            $('.groups-toolbar').removeClass('d-none');
        }
    }
    createMemberGroupForm(){
        let memberGroupFormInstance = new MemberGroupForm('frm-addVpnUserGroupForm-addVpnUserGroupForm', null, true);
        let addMemberGroupButtons = document.querySelectorAll('[data-action="add-member-group"]');
        addMemberGroupButtons.forEach((addMemberGroupButton) => {
            let firstClick = true;
            addMemberGroupButton.addEventListener('click', function (){
                if(firstClick){
                    if(!memberGroupFormInstance.memberGroupsDatatable){
                        memberGroupFormInstance.initAll();
                    }
                    firstClick = false;
                }
                bootstrap.Modal.getOrCreateInstance(document.getElementById('create_member_group_modal')).show();
            });
        });
    }
    inviteMemberFormValidation(){
        let form = document.getElementById('frm-inviteTeamMembersForm-inviteTeamMembersForm');
        if(form){
            this.initTagifyInviteMembers();
            this.initIdentityInput();
            let submitButton = document.getElementById('invite_team_members_form_submit');

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'UsernameInvite': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                    }
                }
            ).on('core.form.validating', function(event) {
                new DismissModal('invite_team_members_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('invite_team_members_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
    initTagifyInviteMembers(){
        const thisClass = this;
        const emailInput = document.querySelector('#frm-inviteTeamMembersForm-inviteTeamMembersForm input[name=UsernameInvite]');
        const groupsInput = document.querySelector('#frm-inviteTeamMembersForm-inviteTeamMembersForm input[name=groups]');
        let notice = $('#inviteMemberFormGroupNotice');
        let membersTotalInOrganizationElement = $(".number-of-members");
        let membersInOrganizationElement = $("#frm-inviteTeamMembersForm-inviteTeamMembersForm .members-in-organization");
        let membersInLicenceElement = $("#frm-inviteTeamMembersForm-inviteTeamMembersForm .members-in-licence");
        let membersCountBadge = $('#frm-inviteTeamMembersForm-inviteTeamMembersForm .badge.members-count');

        if(emailInput){
            let tg = new Tagify(emailInput, {
                pattern: /^(?:(?!.{101,})[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
                keepInvalidTags: false,
                backspace: "edit",
                editTags: 1,
                blacklist: thisClass.vpnUserNames,
                delimiters: ",|;| ,| |:|[\\\r]",
                maxTags: parseInt(membersInLicenceElement.text()) - parseInt(membersInOrganizationElement.text()),
                transformTag: function(tagData) {
                    tagData.value = tagData.value.toLowerCase();
                    return;
                },
            }).on('add', function () {
                let membersInOrganization = parseInt(membersInOrganizationElement.text());
                let membersInLicence = parseInt(membersInLicenceElement.text());
                membersInOrganizationElement.text(membersInOrganization+1);
                if(membersInOrganization+1 >= membersInLicence){
                    membersCountBadge.addClass('badge-light-danger');
                    membersCountBadge.removeClass('badge-light-primary');
                }
            }).on('remove', function(){
                let membersInOrganization = parseInt(membersInOrganizationElement.text());
                let membersInLicence = parseInt(membersInLicenceElement.text());
                membersInOrganizationElement.text(membersInOrganization-1);
                if(membersInOrganization-1 < membersInLicence){
                    membersCountBadge.removeClass('badge-light-danger');
                    membersCountBadge.addClass('badge-light-primary');
                }
            });
            let selectElement = $('select[name="identities"]');
            if(selectElement){
                selectElement.on('change', function(e){
                    tg.loading(true);
                    $.ajax({
                        url: '?do=getIdentityVpnUserNames',
                        type: 'POST',
                        dataType: '',
                        data: {
                            organizationID: thisClass.organizationID,
                            elementID: selectElement.val()
                        }
                    }).done(function(data) {
                        if(data) {
                            tg.settings.blacklist = data;
                            tg.blacklist = data;
                        } else {
                            tg.blacklist = [];
                            tg.settings.blacklist = [];
                        }

                        tg.removeAllTags();
                        tg.loading(false); // render the suggestions dropdown

                        let membersInOrganization = parseInt(membersTotalInOrganizationElement.text());
                        let membersInLicence = parseInt(membersInLicenceElement.text());
                        membersInOrganizationElement.text(membersInOrganization);
                        if(membersInOrganization >= membersInLicence){
                            membersCountBadge.addClass('badge-light-danger');
                            membersCountBadge.removeClass('badge-light-primary');
                        }
                    });
                });
            }
            new SpacebarEvent(tg);
        }

        if(groupsInput){
            let tagify = new GroupsTagify(groupsInput, this.memberGroups);
            tagify.on('add', function(e){
                if(e.detail.data.isInAccessCards && notice){
                    notice.removeClass('d-none');
                }
            }).on('remove', function(e){
                let values = e.detail.tagify.value;
                for(let i in values){
                    if(values[i].isInAccessCards === true){
                        break;
                    }
                }
                notice.addClass('d-none');
            });
        }
    }
    initIdentityInput(){
        // Format options
        var optionFormat = function(item) {
            if ( !item.id ) {
                return item.text;
            }

            var span = document.createElement('span');
            var imgUrl = item.element.getAttribute('data-kt-select2-icon');
            var template = '';

            template += '<img src="/vendor/production/avatars/svg/' + imgUrl + '" class="rounded-circle h-20px me-2" alt="image"/>';
            template += item.text;

            span.innerHTML = template;

            return $(span);
        }

// Init Select2 --- more info: https://select2.org/
        $('#identitySelect').select2({
            templateSelection: optionFormat,
            templateResult: optionFormat
        });
    }
    /** Init tagify inputs for groups in create add device form */
    initAddDeviceTagifyInput(){
        /** In create system form  */
        const groupsInput = document.querySelector('#frm-addDeviceForm-addDeviceForm input[name=groups]');
        let notice = $('#addDeviceFormGroupNotice');
        if(groupsInput){
            let tagify = new GroupsTagify(groupsInput, this.memberGroups);
            tagify.on('add', function(e){
                if(e.detail.data.isInAccessCards && notice){
                    notice.removeClass('d-none');
                }
            }).on('remove', function(e){
                let values = e.detail.tagify.value;
                for(let i in values){
                    if(values[i].isInAccessCards === true){
                        break;
                    }
                }
                notice.addClass('d-none');
            });
        }
    }
    addDeviceFormValidation(){
        const thisClass = this;
        let form = document.getElementById('frm-addDeviceForm-addDeviceForm');
        if(form){
            this.initAddDeviceTagifyInput();

            let submitButton = document.getElementById('members_add_device_form_submit');
            let passwordMeter = KTPasswordMeter.getInstance(form.querySelector('[data-kt-password-meter="true"]'));
            // Password input validation
            const validatePassword = function() {
                return (passwordMeter.getScore() === 100);
            };

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'Username': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Username cannot be over 45 characters',
                                },
                                regexp: {
                                    regexp: /^[a-zA-Z0-9_-]*$/,
                                    message: 'Only these special characters are allowed. (_-)',
                                },
                                remote: {
                                    method: 'POST',
                                    url: '?do=addDeviceForm-IsUniqueVpnUserName',
                                    data: function () {
                                        return {
                                            organizationID: thisClass.organizationID,
                                            username: form.querySelector('input[name=Username]').value,
                                        };
                                    },
                                }
                            }
                        },
                        'Password': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Password has to be between 8 and 45 characters long',
                                },
                                regexp: {
                                    regexp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.])[A-Za-z\d[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.]{8,45}$/,
                                    message: 'You used a forbidden character',
                                },
                                callback: {
                                    message: 'Please enter valid password',
                                    callback: function() {
                                        return validatePassword();
                                    }
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger({
                            delay: {
                                Username: 0.5
                            },
                        }),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.attributes.name.value === 'Password'){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                new DismissModal('members_add_device_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('members_add_device_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
    exportMembersToCsv(){
        let thisClass = this;
        let buttons = document.querySelectorAll('[data-action="export-members-to-csv"]');
        buttons.forEach((button) => {
            button.addEventListener('click', function () {
                thisClass.downloadFile("/team-members/get-members-csv-export?organizationID="+thisClass.organizationID, 'members.csv');
            });
        });
    }
    downloadFile(url, fileName){
        let loadingModal = document.getElementById('loading-modal');
        let hideModal = function () {
            setTimeout(function() {
                bootstrap.Modal.getOrCreateInstance(loadingModal).hide();
            }, 100);
        }
        new bootstrap.Modal(loadingModal).show();
        $.ajax({
            url: url,
            method: 'GET',
            xhrFields: {
                responseType: 'blob'
            },
            success: function (data) {
                const a = document.createElement('a');
                const url = window.URL.createObjectURL(data);
                a.href = url;
                a.download = fileName;
                document.body.append(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                hideModal();
                toastr.success('Members has been successfully downloaded!')
            },
            error: function (request, status, error) {
                hideModal();
                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.')
            }
        });
    }
}
window.Members = Members;